// Single source of truth for app version. Read from package.json at build time.
// To bump version: change `version` in /app/frontend/package.json — this file
// resolves it automatically at build time.
import pkg from "../../package.json";

export const APP_VERSION = pkg.version;
export const APP_NAME = "Debate Engine";
export const APP_PUBLISHER = "An RBG-LLM project";
